import type { FC } from 'react';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import type { NewFeatureTooltipProps } from './types';

export const NewFeatureTooltip: FC<NewFeatureTooltipProps> = ({ isNew, newText, normalText, children, container }) => {
  const content = isNew ? (
    <div className="flex items-center gap-1">
      <span className="rounded bg-blue-500 px-1 py-0.5 font-bold text-white text-xs">new</span>
      {newText}
    </div>
  ) : (
    normalText
  );

  return (
    <CustomTooltip content={content} container={container}>
      {children}
    </CustomTooltip>
  );
};
